import { getEnvVar, getRequiredEnvVar } from "utils/getEnvVar";

const APPSYNC_URL = getRequiredEnvVar("REACT_APP_API_APPSYNC_URL");
const APPSYNC_KEY = getRequiredEnvVar("REACT_APP_API_APPSYNC_KEY");

const USER_POOL_REGION = getRequiredEnvVar("REACT_APP_API_USER_POOL_REGION");
const USER_POOL_ID = getRequiredEnvVar("REACT_APP_USER_POOL_ID");
const USER_POOL_WEB_CLIENT_ID = getRequiredEnvVar(
  "REACT_APP_USER_POOL_WEB_CLIENT_ID"
);
const LOCAL_TOKEN = getEnvVar("REACT_APP_LOCAL_TOKEN");

const WIDGET_DOMAIN = getRequiredEnvVar("REACT_APP_WIDGET_DOMAIN");

const CURRENCY = getEnvVar("REACT_APP_CURRENCY") ?? "USD";

export default {
  APPSYNC_URL,
  APPSYNC_KEY,
  USER_POOL_REGION,
  USER_POOL_ID,
  USER_POOL_WEB_CLIENT_ID,
  LOCAL_TOKEN,
  WIDGET_DOMAIN,
  CURRENCY,
};
